export default "__VITE_ASSET__B_Lb9Y2R__"